<!--
  Redesigned file-upload field. Single integrated dropzone — the empty
  state lives inside the dropzone itself (no separate "Ni naloženih
  datotek" row, no stray native file-input "No file chosen"). When files
  exist they list above as compact chips and the dropzone shrinks to a
  one-line "+ Dodaj še datoteko" CTA so the field label keeps visual
  precedence over the upload affordance.
-->
<div class="briefd-files">
  <!-- Uploaded files — chips. Each row links the filename, shows size,
       has a trash button to remove. -->
  <div *ngIf="files?.length" class="briefd-files__list">
    <div *ngFor="let item of files" class="briefd-files__item">
      <ng-container *ngIf="item.upload; else showLoadingFile">
        <i class="fas fa-file briefd-files__item-icon"></i>
        <a [href]="item.upload.files[0].url + '?download=1'"
           [title]="item.upload.files[0].fileName"
           target="_blank"
           class="briefd-files__item-name">
          {{ item.upload.files[0].fileName }}
        </a>
        <span class="briefd-files__item-size">
          {{ (item.upload.files[0].size / 1000000).toFixed(2) | number }} MB
        </span>
        <button (click)="removeFile(item)" type="button"
                class="briefd-files__item-remove"
                [attr.aria-label]="'Odstrani datoteko'" i18n-aria-label>
          <i class="fas fa-trash-alt"></i>
        </button>
      </ng-container>
      <ng-template #showLoadingFile>
        <i class="fas fa-spinner fa-spin briefd-files__item-icon"></i>
        <span class="briefd-files__item-name briefd-files__item-name--loading"
              i18n="Loading text for file upload">Datoteka se nalaga...</span>
      </ng-template>
    </div>
  </div>

  <!-- Dropzone. Compact one-line CTA when files already exist, full
       "drop area" treatment when the field is empty. Either way the
       upload itself is one element, not three. -->
  <div ngx-dropzone (change)="onSelect($event)" [multiple]="true"
       [attr.data-field]="field?.fieldUuid"
       [attr.data-typeId]="field?.config?.typeId"
       [maxFileSize]="(field?.config?.maxFileSize || 20480) * 1024"
       class="briefd-files__dropzone"
       [class.briefd-files__dropzone--compact]="files?.length">
    <ngx-dropzone-label class="briefd-files__dropzone-label">
      <i class="fas fa-cloud-upload-alt briefd-files__dropzone-icon"></i>
      <span class="briefd-files__dropzone-text">
        <span class="briefd-files__dropzone-cta" i18n>
          {{ files?.length ? 'Dodaj še datoteko' : 'Dodaj datoteko' }}
        </span>
        <span class="briefd-files__dropzone-hint" *ngIf="!files?.length"
              i18n>ali odloži datoteko sem</span>
      </span>
    </ngx-dropzone-label>
  </div>

  <p class="briefd-files__size-hint">
    <i class="fas fa-info-circle"></i>
    <span i18n="file input">Največja dovoljena velikost datoteke je</span>
    {{ (field?.config?.maxFileSize || 20480) / 1024 | number:'1.0-0' }} MB
  </p>
</div>
